import React from 'react';
import Footer from '../components/footer';
import { Popover } from '@headlessui/react';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';


const NoPermissions = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-grow flex justify-center items-start pt-24">
        <div className="bg-gray-50 p-8 rounded-md shadow-md text-center">
          <h1 className="text-2xl font-bold text-indigo-800 mb-4">
            <ExclamationCircleIcon className='h-12 w-full text-center' />
          </h1>
          <h1 className="text-2xl font-bold text-indigo-800 mb-4">
            Accesso Negato
          </h1>
          <p className="text-md text-gray-700 mb-6">
            Non hai i permessi per visualizzare questa risorsa
          </p>
          <a
            href="/"
            className="px-4 py-2 mb-2 md:mr-2 sm:mr-0 rounded-md focus:outline-none bg-indigo-600 text-white shadow-md"
          >
            Torna alla Home
          </a>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NoPermissions;